import React from 'react'
import { convertDate } from '../../routes/lineItems/components/utils';

const HistoryItem = ({ item }) => {

  const createdAt = convertDate(item.createdAt);

  if (item.action === 'ASSIGNED') {
    return (
      <li>
        <i className="axiom-icon-icon icon-user-plus" />
        <div className="history-desc assigned">
          <span>Assigned user:</span> {createdAt} 
          <p>Assigned to {item.assignee} by {item.actionBy}.</p>
        </div>
      </li>
    )
  } else if (item.action === 'APPROVED') {
    return (
      <li>
        <i className="axiom-icon-icon icon-check-circle success" />
        <div className="history-desc approved">
          <span className="success">Approved line item:</span> {createdAt}
          <p>{item.actionBy} approved this lineitem.</p>
        </div>
      </li>
    )
  } else if (item.action === 'REJECTED') {
    return (
      <li>
        <i className="axiom-icon-icon icon-slash error" />
        <div className="history-desc rejected">
          <span className="error">Rejected line item:</span> {createdAt}
          <p>
            {item.actionBy} rejected this lineitem. <br/>
            Comments: {item.comments}
          </p>
        </div>
      </li>
    )
  } else if (item.action === 'UNASSIGNED') {
    return (
      <li>
        <i className="axiom-icon-icon icon-user-x error" />
        <div className="history-desc assigned">
          <span>User unassigned: </span> 
          <p>{item.actionBy}</p>
        </div>
      </li>
    )
  } else {
    return <></>
  }
}

HistoryItem.defaultProps = {
  item: {}
}

export default HistoryItem